<template>
    <component
        :is="type"
        class="w-full block p-4 rounded text-center font-bold tracking-wide uppercase cursor-pointer focus:outline-none"
        :class="conditionalClasses"
        :disabled="disabled"
        :href="to"
        :type="isSubmit"
    >
        <slot/>
    </component>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
        secondary: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: 'a',
        },
        to: {
            type: String,
        },
    },
    computed: {
        isSubmit() {
            return this.type === 'button' ? 'submit' : null
        },
        conditionalClasses() {
            return [
                this.secondary ? 'bg-transparent border-2 border-highlight-80 text-highlight-100 focus:shadow-outline' : 'bg-accent text-white focus:shadow-outline',
                this.disabled ? 'opacity-50' : '',
            ]
        },
    },
}
</script>
